/**
 * Feature flags that can be used to toggle certain features.
 *
 * To enable or disable these feature flags:
 * In Stage/Prod environments, use Janitor to enable for all users, employees, or just specific users.
 */
export const FEATURE_FLAGS = {
  /**
   * Temporary feature flags
   * These flags are useful during the development of new features,
   * but should be removed once the feature enabled for all users.
   */

  // Enables Financial Health Score feature - also used in my-nerdwallet
  FINANCIAL_HEALTH_SCORE: 'financial_health_score_section',
  // List of financial institutions that are no longer supported in Plaid
  FINANCIAL_INSTITUTION_DELISTING: 'web_financial_institution_delisting',
  // Enables migrated Plaid Modal for sandbox testing
  PLAID_MODAL_MIGRATION: 'plaid_modal_sandbox',
  // Enables Web Push notifications footer
  WEB_PUSH_NOTIFICATIONS: 'WebPushNotifications',
  // Enables Transaction Categories v2
  TRANSACTION_CATEGORIES_V2: 'transaction_categories_v2',
  // NerdUp entrypoint v2
  NERDUP_ENTRYPOINT_V2: 'NerdupEntrypointV2',
  // Enables the google pay button on billing details page
  GOOGLE_PAY_BILLING_DETAILS: 'edit_billing_details_google_pay_button',
  // Shows the progress for earning the investment account rewards as a tracker with steps
  INVESTMENT_ACCOUNT_TRACKER: 'investment_account_tracker',
  // Hides the exclusive features carousel
  EXCLUSIVE_FEATURES_CAROUSEL_HIDDEN: 'uex_exclusive_features_carousel_hidden',
  // Makes the ActivatedRewards component the default for the rewards tile for N+ members and not members
  FREEMIUM_PROGRESS_BAR_TILE: 'WebFreemiumProgressBarTile',
  /**
   * Permanent feature flags
   * These feature flags exist even after the feature is enabled for all users.
   * These allow us to enable/disable features depending on product or technical needs.
   */

  // Allow to bypass MFA for NW+ entry points
  BYPASS_MFA: 'bypass_mfa',
  // Shows Credit Builder Card entry point
  CBC_BANNER: 'credit_builder_card_entry_point',
  // When enabled, passes extra data to Auth0 to update copy/images for N+
  NW_PLUS_ONBOARDING_AUTH: 'efx_141_funnel_updates',
  // Enables Google Pay on the N+ checkout form
  NW_PLUS_GOOGLE_PAY: 'nerdwallet_plus_google_pay',
  // Shows the coupon field on the NW+ Checkout page
  NW_PLUS_CHECKOUT_COUPON_FIELD: 'nwplus_checkout_coupon_field',
  // Shows the mailing address form on NW+ checkout
  NW_PLUS_CHECKOUT_MAILING_ADDRESS_FORM: 'nwplus_checkout_mailing_address_form',
  // Emit Rewardable Event When Linking Property
  EMIT_REWARD_LINKED_REDFIN_HOME_VALUE: 'emit_reward_linked_redfin_home_value',
  // Uses the updated getCancelUrl function in login-redirect-handler
  LOGIN_REDIRECT_HANDLER_LOGIC: 'efx_1057_auth_cancel_url_update',
  // Hide ephemeral alerts for freemium users
  SKIP_EPHEMERAL_ALERT_FREEMIUM: 'skip_ephemeral_alert_freemium',
};
